/**
 * Defined in:
 *   {@link file://./../../../dxos/client/services.proto}
 */
export var SystemStatus;
(function (SystemStatus) {
    SystemStatus[SystemStatus["INACTIVE"] = 0] = "INACTIVE";
    SystemStatus[SystemStatus["ACTIVE"] = 1] = "ACTIVE";
})(SystemStatus || (SystemStatus = {}));
export var GetDiagnosticsRequest;
(function (GetDiagnosticsRequest) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let KEY_OPTION;
    (function (KEY_OPTION) {
        KEY_OPTION[KEY_OPTION["NONE"] = 0] = "NONE";
        KEY_OPTION[KEY_OPTION["TRUNCATE"] = 1] = "TRUNCATE";
        KEY_OPTION[KEY_OPTION["HUMANIZE"] = 2] = "HUMANIZE";
    })(KEY_OPTION = GetDiagnosticsRequest.KEY_OPTION || (GetDiagnosticsRequest.KEY_OPTION = {}));
})(GetDiagnosticsRequest || (GetDiagnosticsRequest = {}));
export var Platform;
(function (Platform) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let PLATFORM_TYPE;
    (function (PLATFORM_TYPE) {
        PLATFORM_TYPE[PLATFORM_TYPE["BROWSER"] = 0] = "BROWSER";
        PLATFORM_TYPE[PLATFORM_TYPE["SHARED_WORKER"] = 1] = "SHARED_WORKER";
        PLATFORM_TYPE[PLATFORM_TYPE["NODE"] = 2] = "NODE";
        PLATFORM_TYPE[PLATFORM_TYPE["DEDICATED_WORKER"] = 3] = "DEDICATED_WORKER";
    })(PLATFORM_TYPE = Platform.PLATFORM_TYPE || (Platform.PLATFORM_TYPE = {}));
})(Platform || (Platform = {}));
/**
 * Defined in:
 *   {@link file://./../../../dxos/client/services.proto}
 */
export var DeviceKind;
(function (DeviceKind) {
    DeviceKind[DeviceKind["CURRENT"] = 0] = "CURRENT";
    DeviceKind[DeviceKind["TRUSTED"] = 1] = "TRUSTED";
})(DeviceKind || (DeviceKind = {}));
export var Device;
(function (Device) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let PresenceState;
    (function (PresenceState) {
        PresenceState[PresenceState["OFFLINE"] = 0] = "OFFLINE";
        PresenceState[PresenceState["ONLINE"] = 1] = "ONLINE";
        PresenceState[PresenceState["REMOVED"] = 2] = "REMOVED";
    })(PresenceState = Device.PresenceState || (Device.PresenceState = {}));
})(Device || (Device = {}));
export var SpaceMember;
(function (SpaceMember) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let PresenceState;
    (function (PresenceState) {
        PresenceState[PresenceState["OFFLINE"] = 0] = "OFFLINE";
        PresenceState[PresenceState["ONLINE"] = 1] = "ONLINE";
    })(PresenceState = SpaceMember.PresenceState || (SpaceMember.PresenceState = {}));
})(SpaceMember || (SpaceMember = {}));
export var CreateEpochRequest;
(function (CreateEpochRequest) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let Migration;
    (function (Migration) {
        Migration[Migration["NONE"] = 0] = "NONE";
        Migration[Migration["INIT_AUTOMERGE"] = 1] = "INIT_AUTOMERGE";
        Migration[Migration["PRUNE_AUTOMERGE_ROOT_HISTORY"] = 2] = "PRUNE_AUTOMERGE_ROOT_HISTORY";
        Migration[Migration["FRAGMENT_AUTOMERGE_ROOT"] = 3] = "FRAGMENT_AUTOMERGE_ROOT";
        Migration[Migration["REPLACE_AUTOMERGE_ROOT"] = 4] = "REPLACE_AUTOMERGE_ROOT";
        Migration[Migration["MIGRATE_REFERENCES_TO_DXN"] = 5] = "MIGRATE_REFERENCES_TO_DXN";
    })(Migration = CreateEpochRequest.Migration || (CreateEpochRequest.Migration = {}));
})(CreateEpochRequest || (CreateEpochRequest = {}));
export var SpaceArchive;
(function (SpaceArchive) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let Format;
    (function (Format) {
        Format[Format["BINARY"] = 0] = "BINARY";
        Format[Format["JSON"] = 1] = "JSON";
    })(Format = SpaceArchive.Format || (SpaceArchive.Format = {}));
})(SpaceArchive || (SpaceArchive = {}));
export var QueryInvitationsResponse;
(function (QueryInvitationsResponse) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let Action;
    (function (Action) {
        Action[Action["ADDED"] = 0] = "ADDED";
        Action[Action["REMOVED"] = 1] = "REMOVED";
        Action[Action["SAVED"] = 2] = "SAVED";
        Action[Action["LOAD_COMPLETE"] = 3] = "LOAD_COMPLETE";
    })(Action = QueryInvitationsResponse.Action || (QueryInvitationsResponse.Action = {}));
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let Type;
    (function (Type) {
        Type[Type["CREATED"] = 0] = "CREATED";
        Type[Type["ACCEPTED"] = 1] = "ACCEPTED";
    })(Type = QueryInvitationsResponse.Type || (QueryInvitationsResponse.Type = {}));
})(QueryInvitationsResponse || (QueryInvitationsResponse = {}));
/**
 * Defined in:
 *   {@link file://./../../../dxos/client/services.proto}
 */
export var ConnectionState;
(function (ConnectionState) {
    ConnectionState[ConnectionState["OFFLINE"] = 0] = "OFFLINE";
    ConnectionState[ConnectionState["ONLINE"] = 1] = "ONLINE";
})(ConnectionState || (ConnectionState = {}));
export var EdgeStatus;
(function (EdgeStatus) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let ConnectionState;
    (function (ConnectionState) {
        ConnectionState[ConnectionState["NOT_CONNECTED"] = 0] = "NOT_CONNECTED";
        ConnectionState[ConnectionState["CONNECTED"] = 1] = "CONNECTED";
    })(ConnectionState = EdgeStatus.ConnectionState || (EdgeStatus.ConnectionState = {}));
})(EdgeStatus || (EdgeStatus = {}));
export var QueryAgentStatusResponse;
(function (QueryAgentStatusResponse) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/services.proto}
     */
    let AgentStatus;
    (function (AgentStatus) {
        AgentStatus[AgentStatus["UNKNOWN"] = 0] = "UNKNOWN";
        AgentStatus[AgentStatus["ACTIVE"] = 1] = "ACTIVE";
        AgentStatus[AgentStatus["INACTIVE"] = 2] = "INACTIVE";
        AgentStatus[AgentStatus["NOT_FOUND"] = 3] = "NOT_FOUND";
    })(AgentStatus = QueryAgentStatusResponse.AgentStatus || (QueryAgentStatusResponse.AgentStatus = {}));
})(QueryAgentStatusResponse || (QueryAgentStatusResponse = {}));
/**
 * Runtime state of the space object.
 *
 * Defined in:
 *   {@link file://./../../../dxos/client/invitation.proto}
 */
export var SpaceState;
(function (SpaceState) {
    SpaceState[SpaceState["INVALID"] = 0] = "INVALID";
    SpaceState[SpaceState["SPACE_INACTIVE"] = 2] = "SPACE_INACTIVE";
    SpaceState[SpaceState["SPACE_ACTIVE"] = 6] = "SPACE_ACTIVE";
    SpaceState[SpaceState["SPACE_DELETED"] = 9] = "SPACE_DELETED";
    SpaceState[SpaceState["SPACE_CLOSED"] = 1] = "SPACE_CLOSED";
    SpaceState[SpaceState["SPACE_CONTROL_ONLY"] = 7] = "SPACE_CONTROL_ONLY";
    SpaceState[SpaceState["SPACE_INITIALIZING"] = 4] = "SPACE_INITIALIZING";
    SpaceState[SpaceState["SPACE_READY"] = 3] = "SPACE_READY";
    SpaceState[SpaceState["SPACE_ERROR"] = 5] = "SPACE_ERROR";
    SpaceState[SpaceState["SPACE_REQUIRES_MIGRATION"] = 8] = "SPACE_REQUIRES_MIGRATION";
})(SpaceState || (SpaceState = {}));
export var Invitation;
(function (Invitation) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/invitation.proto}
     */
    let Type;
    (function (Type) {
        Type[Type["INTERACTIVE"] = 0] = "INTERACTIVE";
        Type[Type["DELEGATED"] = 1] = "DELEGATED";
        Type[Type["MULTIUSE"] = 2] = "MULTIUSE";
    })(Type = Invitation.Type || (Invitation.Type = {}));
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/invitation.proto}
     */
    let Kind;
    (function (Kind) {
        Kind[Kind["INVALID"] = 0] = "INVALID";
        Kind[Kind["DEVICE"] = 1] = "DEVICE";
        Kind[Kind["SPACE"] = 2] = "SPACE";
    })(Kind = Invitation.Kind || (Invitation.Kind = {}));
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/invitation.proto}
     */
    let AuthMethod;
    (function (AuthMethod) {
        AuthMethod[AuthMethod["NONE"] = 0] = "NONE";
        AuthMethod[AuthMethod["SHARED_SECRET"] = 1] = "SHARED_SECRET";
        AuthMethod[AuthMethod["KNOWN_PUBLIC_KEY"] = 2] = "KNOWN_PUBLIC_KEY";
    })(AuthMethod = Invitation.AuthMethod || (Invitation.AuthMethod = {}));
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/invitation.proto}
     */
    let State;
    (function (State) {
        State[State["INIT"] = 0] = "INIT";
        State[State["CONNECTING"] = 1] = "CONNECTING";
        State[State["CONNECTED"] = 2] = "CONNECTED";
        State[State["READY_FOR_AUTHENTICATION"] = 3] = "READY_FOR_AUTHENTICATION";
        State[State["AUTHENTICATING"] = 4] = "AUTHENTICATING";
        State[State["SUCCESS"] = 5] = "SUCCESS";
        State[State["CANCELLED"] = 6] = "CANCELLED";
        State[State["TIMEOUT"] = 7] = "TIMEOUT";
        State[State["ERROR"] = 8] = "ERROR";
        State[State["EXPIRED"] = 9] = "EXPIRED";
    })(State = Invitation.State || (Invitation.State = {}));
})(Invitation || (Invitation = {}));
/**
 * Defined in:
 *   {@link file://./../../../dxos/client/logging.proto}
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["NONE"] = 0] = "NONE";
    LogLevel[LogLevel["TRACE"] = 5] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 10] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 11] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 12] = "INFO";
    LogLevel[LogLevel["WARN"] = 13] = "WARN";
    LogLevel[LogLevel["ERROR"] = 14] = "ERROR";
})(LogLevel || (LogLevel = {}));
export var QueryLogsRequest;
(function (QueryLogsRequest) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/client/logging.proto}
     */
    let MatchingOptions;
    (function (MatchingOptions) {
        MatchingOptions[MatchingOptions["NONE"] = 0] = "NONE";
        MatchingOptions[MatchingOptions["INCLUSIVE"] = 1] = "INCLUSIVE";
        MatchingOptions[MatchingOptions["EXPLICIT"] = 2] = "EXPLICIT";
    })(MatchingOptions = QueryLogsRequest.MatchingOptions || (QueryLogsRequest.MatchingOptions = {}));
})(QueryLogsRequest || (QueryLogsRequest = {}));
//# sourceMappingURL=services.js.map